module.exports = __webpack_public_path__ + "media/assets/icons/search-b50b40a1b09f159045bbaef33340432c.svg";